var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRowIconSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.663 2.014H4.087c-.662 0-1.198.536-1.198 1.198v13.576c0 .662.536 1.198 1.198 1.198h13.576c.662 0 1.198-.536 1.198-1.198V3.212c0-.662-.536-1.198-1.198-1.198z",
    stroke: "#1B264F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.281 2.014v15.972M2.889 7.22l15.972-.015M2.889 12.603l15.972-.015",
    stroke: "#1B264F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "media/icons/rowIconSelected-45c4ac34.svg";
export { SvgRowIconSelected as ReactComponent };